export default "__VITE_ASSET__CX53CxPz__"